import { useEffect, useState } from "react";

export function useClientHostname() {
  const [hostname, setHostname] = useState<string | null>(null);

  useEffect(() => {
    setHostname(window.location.hostname);
  }, []);

  return hostname;
}
